<template>
  <div class="flex items-center space-x-2 align-top">
    <div class="tooltip-orb">
      <div :class="getStatusColor(product)" class="w-3 h-3 rounded-full" :title="getStatusText(product)">
        <span class="hidden">{{ getStatusText(product) }}</span>
      </div>
    </div>
    <span class="py-1">
      <u-brick-dimension-display :measurements="product.measurements" />
      <div class="flex items-center font-heading text-gray-400 text-sm sm:ml-auto">
        {{ product.type ?? "Type not specified" }}
      </div>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getStatusText(product) {
      return product.production?.in_production ? 'In Production' : 'Not In Production';
    },
    // Method to get status color for each variant
    getStatusColor(product) {
      return product.production?.in_production ? 'bg-green-500' : 'bg-orange-400';
    },
  },
};
</script>
